import { render, staticRenderFns } from "./flickity.vue?vue&type=template&id=42695eab"
import script from "./flickity.vue?vue&type=script&lang=js"
export * from "./flickity.vue?vue&type=script&lang=js"
import style0 from "flickity/dist/flickity.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports